
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pro/briefings/about",
      function () {
        return require("private-next-pages/pro/briefings/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pro/briefings/about"])
      });
    }
  